import React, { useEffect, useState } from "react";
import { Table, Typography } from "antd";
import { BOM } from "../../../../services/definedMethod";

const { Text } = Typography;

export const defaultChargeSlabs = [
  {
    id: 1,
    fromAmount: 0,
    toAmount: 50000,
    consumeLimits: true,
    flatOrPercentage: "Flat",
    amount: 150,
  },
  {
    id: 2,
    fromAmount: 50001,
    toAmount: 250000,
    consumeLimits: false,
    flatOrPercentage: "Percentage",
    amount: 1.5,
  },
  {
    id: 3,
    fromAmount: 250001,
    toAmount: 1000000,
    consumeLimits: true,
    flatOrPercentage: "Flat",
    amount: 750,
  },
];

const columns = [
  {
    title: "From amount",
    dataIndex: "fromAmount",
  },
  {
    title: "To amount",
    dataIndex: "toAmount",
  },
  {
    title: "Consume Limits",
    dataIndex: "consumeLimits",
  },
  {
    title: "Flat or Percentage",
    dataIndex: "flatOrPercentage",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
];

const formatDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }
  return value;
};

const formatAmountValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (typeof value === "number") {
    return BOM.FormatAmount(value);
  }
  return value;
};

const resolveFlatOrPercentage = (slab) => {
  const value =
    slab?.flatOrPercentage ??
    slab?.chargeCalculationType?.value ??
    slab?.calculationType?.value ??
    slab?.calculationType ??
    slab?.type;

  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (typeof value === "boolean") {
    return value ? "Flat" : "Percentage";
  }
  return value;
};

export const normalizeChargeSlab = (element, index) => {
  const key = element?.id ?? element?.key ?? index + 1;

  return {
    id: key,
    key,
    fromAmount: element?.fromAmount ?? element?.fromamount ?? 0,
    toAmount: element?.toAmount ?? element?.toamount ?? 0,
    consumeLimits: Boolean(
      element?.consumeLimits ?? element?.consumeLimit ?? element?.consumeLimitCount ?? false,
    ),
    flatOrPercentage:
      resolveFlatOrPercentage(element) === "-"
        ? "Flat"
        : resolveFlatOrPercentage(element),
    amount: element?.amount ?? 0,
  };
};

export const buildChargeSlabList = (chargeDetail) => {
  const slabs =
    chargeDetail?.chargeSlabs ??
    chargeDetail?.chargeSlab ??
    chargeDetail?.slabs ??
    [];

  const source = Array.isArray(slabs) && slabs.length > 0 ? slabs : defaultChargeSlabs;

  return source.map((element, index) => normalizeChargeSlab(element, index));
};

const mapChargeSlabs = (chargeSlabs = []) =>
  chargeSlabs.map((element) => ({
    key: element.key,
    fromAmount: formatAmountValue(element.fromAmount),
    toAmount: formatAmountValue(element.toAmount),
    consumeLimits: formatDisplayValue(element.consumeLimits),
    flatOrPercentage: element.flatOrPercentage,
    amount: formatAmountValue(element.amount),
  }));

export default function ChargeSlab({
  chargeSlabs = [],
  onSelectionChange,
  resetSelection,
}) {
  const [chargeSlabList, setChargeSlabList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    setChargeSlabList(mapChargeSlabs(chargeSlabs));
  }, [chargeSlabs]);

  useEffect(() => {
    setSelectedRowKeys([]);
    onSelectionChange?.([], []);
  }, [resetSelection]);

  const onSelectItemAction = (selectedKeys, selectedRows) => {
    setSelectedRowKeys(selectedKeys);
    onSelectionChange?.(selectedRows, selectedKeys);
  };

  return (
    <Table
      rowSelection={{
        type: "radio",
        selectedRowKeys,
        onChange: onSelectItemAction,
      }}
      columns={columns}
      dataSource={chargeSlabList}
      bordered
      pagination={{
        position: "bottomCentre",
      }}
      locale={{
        emptyText: <Text type="secondary">No charge slabs available</Text>,
      }}
    />
  );
}
